export default __webpack_public_path__ + "static/media/slider1-right.262f7ce0.svg";